"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/styles");
const bind_1 = __importDefault(require("classnames/bind"));
const CommonPopupFooter_scss_1 = __importDefault(require("@/components/popup/CommonPopupFooter.scss"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const cx = bind_1.default.bind(CommonPopupFooter_scss_1.default);
const useStyles3 = (0, styles_1.makeStyles)(() => ({
    commonPopupRightBtn: {
        minWidth: '124px',
        height: '38px',
        fontFamily: '"Open Sans", Helvetica,Arial,sans-serif',
        fontWeight: 'bold',
        fontSize: '13px',
        textTransform: 'none',
        color: '#ffffff',
        padding: '9px 12px',
        lineHeight: 'normal'
    },
    btnSubmitDisabled: {
        color: '#C4C7CE !important'
    }
}));
const CommonPopupFooter = ({ footerType = '3', leftLabel, leftClickHandler, rightDisabled, rightLabel, rightClickHandler }) => {
    const classes3 = useStyles3();
    const rightBtn = 'common-popup-right-btn';
    return (react_1.default.createElement("div", { className: `${cx('common-popup-footer-container')} ${footerType === '1' || footerType === '2' ? cx('common-popup-footer-container-type-1') : ''}` },
        footerType === '1' ? (react_1.default.createElement(Button_1.default, { disabled: rightDisabled, className: `${classes3.commonPopupRightBtn} ${cx(rightBtn)} ${rightDisabled ? classes3.btnSubmitDisabled : ''}`, variant: "contained", name: "OK", disableTouchRipple: true, disableFocusRipple: true, onClick: rightClickHandler }, rightLabel)) : null,
        footerType === '2' ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { id: "leftIconType2", className: cx('common-popup-left-icon'), onClick: leftClickHandler }),
            react_1.default.createElement("div", { id: "leftBtnType2", className: cx('common-popup-left-btn'), onClick: leftClickHandler }, leftLabel),
            react_1.default.createElement(Button_1.default, { className: `${classes3.commonPopupRightBtn} ${cx(rightBtn)} ${rightDisabled ? classes3.btnSubmitDisabled : ''}`, name: "OK", variant: "contained", disableTouchRipple: true, disableFocusRipple: true, onClick: rightClickHandler, disabled: rightDisabled }, rightLabel))) : null,
        footerType === '3' ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { id: "leftIconType3", className: cx('common-popup-left-icon'), onClick: leftClickHandler }),
            react_1.default.createElement("div", { id: "leftIconType3", className: cx('common-popup-left-btn'), onClick: leftClickHandler }, leftLabel),
            react_1.default.createElement(Button_1.default, { disabled: rightDisabled, className: `${classes3.commonPopupRightBtn} ${cx(rightBtn)} ${rightDisabled ? classes3.btnSubmitDisabled : ''}`, variant: "contained", name: "OK", disableTouchRipple: true, disableFocusRipple: true, onClick: rightClickHandler }, rightLabel))) : null));
};
exports.default = CommonPopupFooter;
